/**
 * handleFailedItemsRequest.js
 *
 * Copyright (c) apploft. GmbH
 */

import {ready} from '../ContentStateSymbol';

export default function handleFailedItemsRequest({error, section, api}) {
  return {state: ready, data: {message: error.message, section, api}};
}
